/*
 * Planet Action Figures: restyle only the Appstle loyalty login prompt
 * when it is present inside the cart drawer. The Appstle widget and its
 * links remain intact; no text, rewards, or event handlers are replaced.
 */
(() => {
  if (window.__pafCartRewardsStylerLoaded) return;
  window.__pafCartRewardsStylerLoaded = true;

  const promptText = 'redeem your points for rewards';

  function markAppstleLoginPanel() {
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || footer.querySelector('.paf-appstle-rewards-panel')) return;

    const links = footer.querySelectorAll('a, button');
    for (const link of links) {
      if (link.textContent.trim().toLowerCase() !== 'log in') continue;

      // Keep the search inside the cart footer, never touch the theme login.
      let prompt = link.parentElement;
      while (prompt && prompt !== footer && !prompt.textContent.toLowerCase().includes(promptText)) {
        prompt = prompt.parentElement;
      }
      if (!prompt || prompt === footer) continue;

      // Appstle draws its own bordered wrapper. Prefer styling that box
      // instead of introducing an extra box around the login message.
      let panel = prompt;
      let parent = prompt.parentElement;
      for (let i = 0; i < 5 && parent && parent !== footer; i++, parent = parent.parentElement) {
        if (parent.querySelector('.paf-cart-summary, .cart__checkout-button')) break;
        const border = window.getComputedStyle(parent);
        if (border.borderTopStyle !== 'none' && parseFloat(border.borderTopWidth) > 0) {
          panel = parent;
          break;
        }
      }
      panel.classList.add('paf-appstle-rewards-panel');
      return;
    }
  }

  // Appstle's wrapper has a narrower content area than the cart checkout.
  // Size the rewards panel to the checkout button and correct its offset.
  // This only adjusts layout; it never changes the Appstle link or markup.
  function alignAppstlePanel() {
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    const panel = footer?.querySelector('.paf-appstle-rewards-panel');
    const checkout = footer?.querySelector('#CartDrawer-Checkout');
    if (!panel || !checkout || !panel.isConnected) return;

    const checkoutRect = checkout.getBoundingClientRect();
    if (checkoutRect.width < 1) return;

    panel.style.setProperty('--paf-rewards-width', checkoutRect.width + 'px');
    // Reset the prior correction before measuring to avoid compounding shifts.
    panel.style.setProperty('--paf-rewards-dx', '0px');
    const panelRect = panel.getBoundingClientRect();
    panel.style.setProperty('--paf-rewards-dx', (checkoutRect.left - panelRect.left).toFixed(2) + 'px');
  }

  function init() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    let pendingFrame = 0;
    function scheduleAlignment() {
      if (pendingFrame) return;
      pendingFrame = window.requestAnimationFrame(() => {
        pendingFrame = 0;
        markAppstleLoginPanel();
        alignAppstlePanel();
      });
    }

    scheduleAlignment();
    const observer = new MutationObserver(scheduleAlignment);
    observer.observe(drawer, { childList: true, subtree: true });
    window.addEventListener('resize', scheduleAlignment, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
